import { ComponentRenderer } from 'app/src/features/Tutorial/components/ComponentRenderer'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { PageWidget } from 'app/src/shared/components'
import { useComponentRenderer, usePageTitle, useTranslation, useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, type ReactElement } from 'react'

export function Tutorial(): ReactElement {
  const context = useWebAppContext()
  const { getPage } = useComponentRenderer()
  const tutorialPageConfig = pageconfigurationsApi.usePageRequestGet(
    {
      pathParams: { id: 'tutorial', templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
    },
    { meta: { context } },
  )
  const { t } = useTranslation('tutorial')
  usePageTitle(t('Tutorial.InformativeSection.Title'))
  useEffect(() => {
    context.update({ breadCrumbItems: [] })

    //evita loop su contesto
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <PageWidget containerClassNamesOverrides='mb-1'>
        <h1 className='text-3xl font-bold'>{t('Tutorial.InformativeSection.Title')}</h1>
      </PageWidget>
      {ComponentRenderer(getPage(tutorialPageConfig?.data))}
    </>
  )
}
